import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d826ad6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 col-lg-8" }
const _hoisted_3 = { class: "d-flex justify-content-between mb-10" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex flex-column align-items-center m-2 mt-5"
}
const _hoisted_5 = { class: "mb-5" }
const _hoisted_6 = { class: "d-flex flex-column align-items-center m-2 mt-5" }
const _hoisted_7 = { class: "mb-5" }
const _hoisted_8 = { class: "mb-10" }
const _hoisted_9 = { class: "d-flex mb-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flash-bar bg-opacity-75" }, null, -1))
const _hoisted_11 = { class: "mt-1" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "col-12 col-lg-4" }
const _hoisted_15 = { class: "d-flex flex-column gap-3" }
const _hoisted_16 = { class: "text-gray-800 fs-6 fw-bold" }
const _hoisted_17 = {
  key: 0,
  class: "text-muted fs-7 mb-0 mt-1"
}
const _hoisted_18 = { class: "row documents-card" }
const _hoisted_19 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BasicCard = _resolveComponent("BasicCard")!
  const _component_AttachmentFileItem = _resolveComponent("AttachmentFileItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.cmsData.isDossierOngoing)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t('views.portal.home.altSearchLabel')), 1),
              _createVNode(_component_router_link, {
                to: { name: 'portal-search'},
                class: "btn btn-primary btn-violet w-100"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('views.portal.home.altSearchLink')), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.$t('views.portal.home.altCasesLabel')), 1),
          _createVNode(_component_router_link, {
            to: { name: 'portal-cases'},
            class: "btn btn-primary btn-violet w-100"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('views.portal.home.altCasesLink')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_BasicCard, { class: "bg-info bg-opacity-25" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.cmsData.cmsInfo?.news?.title), 1)
            ]),
            _createElementVNode("p", {
              innerHTML: _ctx.cmsData.cmsInfo?.news?.text
            }, null, 8, _hoisted_12)
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_BasicCard, {
        title: _ctx.cmsData.cmsInfo?.information?.title
      }, {
        default: _withCtx(() => [
          _createElementVNode("p", {
            ref: "information",
            innerHTML: _ctx.cmsData.cmsInfo?.information?.text
          }, null, 8, _hoisted_13)
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    _createElementVNode("div", _hoisted_14, [
      (_ctx.hasUpcomingAteliers)
        ? (_openBlock(), _createBlock(_component_BasicCard, {
            key: 0,
            class: "mb-10 mt-10 mt-lg-0",
            title: _ctx.$t('views.portal.home.careerCenterTitle')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_router_link, {
                  to: { name: 'portal-ateliers', params: { type: 'webinaire-alternance' } },
                  class: "btn btn-primary btn-violet fw-bold"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('views.portal.home.careerCenterWebinaire')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: { name: 'portal-ateliers', params: { type: 'atelier-coaching' } },
                  class: "btn btn-primary btn-violet fw-bold"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('views.portal.home.careerCenterCoaching')), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["title"]))
        : _createCommentVNode("", true),
      (_ctx.registeredAteliers.length)
        ? (_openBlock(), _createBlock(_component_BasicCard, {
            key: 1,
            class: "mb-10 mt-10 mt-lg-0",
            title: _ctx.$t('views.portal.home.myAteliersTitle')
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.registeredAteliers, (atelier, i) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  key: i,
                  to: { name: 'portal-ateliers', params: { type: atelier.type.replace(/_/g, '-') } },
                  class: _normalizeClass(["d-block py-3 text-decoration-none", { 'border-bottom': i < _ctx.registeredAteliers.length - 1 }])
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.formatDate(atelier.dateDebut || atelier.date || '')) + " - " + _toDisplayString(atelier.intitule || atelier.name) + " - " + _toDisplayString(_ctx.formatHour(atelier.dateDebut || atelier.date || '')), 1),
                    (atelier.description)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(atelier.description), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["to", "class"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["title"]))
        : _createCommentVNode("", true),
      _createVNode(_component_BasicCard, {
        id: "documents",
        class: "mb-10 mt-10 mt-lg-0",
        title: _ctx.$t('views.portal.home.documentsCardTitle')
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_18, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.publicFiles, (file, i) => {
              return (_openBlock(), _createBlock(_component_AttachmentFileItem, {
                class: "my-2",
                attachment: file,
                key: i
              }, null, 8, ["attachment"]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["title"]),
      _createVNode(_component_BasicCard, {
        class: "mb-10 mt-10 mt-lg-0",
        title: _ctx.cmsData.cmsInfo?.links?.title
      }, {
        default: _withCtx(() => [
          _createElementVNode("p", {
            innerHTML: _ctx.cmsData.cmsInfo?.links?.text
          }, null, 8, _hoisted_19)
        ]),
        _: 1
      }, 8, ["title"])
    ])
  ]))
}